import styled from 'styled-components'

import Link from 'components/Link'
import Pill from 'components/Pill'
import Heading from 'components/Heading'

import { VersionLink } from 'modules/versioning'
import { breakpoint } from 'utils'

import { ReactComponent as ArrowRightCircleIcon } from 'icons/arrow-right-circle-24.svg'

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  margin-top: 28px;
  border-top: 1px solid ${({ theme }) => theme.colors.border.dark.base};

  & + & {
    margin-top: 40px;
  }

  :first-child {
    border-top: none;
  }

  padding: 0 20px;

  ${breakpoint('sm')`
    padding: 0 40px;
  `}
`

export const StyledPageLink = styled(Link)`
  color: ${({ theme }) => theme.colors.text.dark.base};
  font-weight: 500;

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.text.dark.secondary};
  }
` as typeof Link

export const Title = styled(Heading.H3)`
  margin: 0;
`

export const StyledPageTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  margin-bottom: 28px;
`
export const StyledPageCanvasLink = styled(Link)`
  font-size: ${({ theme }) => theme.fontSizes.smaller};
  font-weight: 500;
`

export const StyledVersionLink = styled(VersionLink)`
  display: block;
`
export const StyledBetaPill = styled(Pill)`
  margin-left: 4px;
`

export const FullScreenContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`

export const StyledArrowRightCircleIcon = styled(ArrowRightCircleIcon)`
  height: 24px;
  vertical-align: top;
  margin-left: 8px;
  color: ${({ theme }) => theme.colors.tint.default};
`
